import {
  CardMeta,
  ManagementCard,
  ManagementCardAction,
  ManagementCardList,
} from 'components/ManagementCard'
import { ScheduledReservation, TTag } from 'types'
import { TAutoReplyMessageAsset } from 'api'
import { commonStrings, sendAllMessageStrings } from '../../../constants'
import { getDraftPreviewLabel } from '../Drafts/draftPreview'
import { getReservationRecipientLabel } from './reservationRecipient'
import { formatScheduledDateTime } from './reservationScheduledDateTime'

type ReservationsCardListProps = {
  reservations: ScheduledReservation[]
  assets: TAutoReplyMessageAsset[]
  tags: TTag[]
  loading: boolean
  onEdit: (reservationId: string) => void
  onCancel: (reservationId: string) => void
  onPreview: (reservation: ScheduledReservation) => void
  className?: string
}

export function ReservationsCardList({
  reservations,
  assets,
  tags,
  loading,
  onEdit,
  onCancel,
  onPreview,
  className,
}: ReservationsCardListProps) {
  return (
    <ManagementCardList
      loading={loading}
      isEmpty={reservations.length === 0}
      loadingMessage={sendAllMessageStrings.reservations.loading}
      emptyMessage={sendAllMessageStrings.reservations.empty}
      className={className}
    >
      {reservations.map((reservation) => (
        <li key={reservation.id}>
          <ManagementCard
            onClick={
              reservation.editable
                ? () => onEdit(reservation.id)
                : undefined
            }
            ariaLabel={`${formatScheduledDateTime(reservation.scheduledDateTime)} ${sendAllMessageStrings.reservations.actions.edit}`}
            title={formatScheduledDateTime(reservation.scheduledDateTime)}
            titleSuffix={`${reservation.sections.length}${commonStrings.countSuffix}`}
            actions={
              <>
                <ManagementCardAction onClick={() => onPreview(reservation)}>
                  {sendAllMessageStrings.reservations.actions.preview}
                </ManagementCardAction>
                <ManagementCardAction
                  tone="danger"
                  onClick={() => onCancel(reservation.id)}
                >
                  {sendAllMessageStrings.reservations.actions.cancel}
                </ManagementCardAction>
              </>
            }
          >
            <p className="line-clamp-2 text-xs text-muted">
              {getDraftPreviewLabel(reservation, assets)}
            </p>
            <CardMeta
              label={sendAllMessageStrings.reservations.table.recipient}
              value={getReservationRecipientLabel(reservation, tags)}
            />
            <CardMeta
              label={sendAllMessageStrings.reservations.table.createdBy}
              value={reservation.createdByName}
            />
            {!reservation.editable && (
              <p className="text-xs text-muted">
                {sendAllMessageStrings.reservations.notEditableHint}
              </p>
            )}
          </ManagementCard>
        </li>
      ))}
    </ManagementCardList>
  )
}
